import AxiosInterceptor from "../../AxiosInterceptorAlcohol";

// 주별 학습 진행 현황 조회
// request data
//  - pid
export function getEducationProgressWeekFromAlcohol(request) {
    return AxiosInterceptor({
        url: '/analysis/status/progress-week',
        method: 'get',
        params: request
    })
}


// AUDIT-K 점수 조회
// request data
//  - pid
export function getAuditScoreFromAlcohol(request) {
    return AxiosInterceptor({
        url: '/screening/audit-k/score',
        method: 'get',
        params: request
    })
}


// RTCQ 단계 결과 조회
// request data
//  - pid
export function getRtcqStageFromAlcohol(request) {
    return AxiosInterceptor({
        url: '/screening/rtcq/stage',
        method: 'get',
        params: request
    })
}


// AUDIT-K 질문 정보 조회
// request data
//  - pid
export function getAuditQuestionFromAlcohol(request) {
    return AxiosInterceptor({
        url: '/screening/audit-k',
        method: 'get',
        params: request
    })
}


// RTCQ 질문 정보 조회
// request data
//  - pid
export function getRtcqQuestionFromAlcohol(request) {
    return AxiosInterceptor({
        url: '/screening/rtcq',
        method: 'get',
        params: request
    })
}